import {FC, useEffect, useState} from 'react';
import {Modal, Col, Row, Input, Form} from 'antd';
import {FaAddressBook} from 'react-icons/fa';
import {useIntl} from 'react-intl';
import {validationInputNumber} from 'src/shared/functions/validation-input-number';
import {OrderDetailsItemsDto} from 'src/shared/services/orders/dto/order-details-items-dto';
import {ordersService} from 'src/shared/services/orders';
import {OrderDetailsDto} from 'src/shared/services/orders/dto/order-details-dto';

interface IStockBreakQuantityModalProps {
  visible: boolean;
  orderDetails?: OrderDetailsDto;
  orderDetailsItems?: OrderDetailsItemsDto;
  onCancel: () => void;
  onFinish: () => void;
}

const StockBreakQuantityModal: FC<IStockBreakQuantityModalProps> = ({
  visible,
  orderDetails,
  orderDetailsItems,
  onCancel,
  onFinish,
}) => {
  const {messages} = useIntl();

  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    if (visible) setQuantity(0);
  }, [visible]);

  const onOk = async () => {
    try {
      await ordersService.setOrderItemAsStockBreak({
        orderId: orderDetails?.Id ?? '',
        orderItemId: orderDetailsItems?.Id ?? '',
        quantity: quantity,
        status: true,
      });
      onFinish();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      className='add-info-modal'
      width={'500px'}
      centered
      onCancel={() => onCancel()}
      onOk={onOk}
      okButtonProps={{disabled: quantity > 0 ? false : true}}
      maskClosable={false}
      open={visible}
      title={messages['orders.subOrders.stockBreakQuantity'].toString()}>
      <Form layout='vertical'>
        <Form.Item
          label={messages['orders.returnExchange.quantity'].toString()}>
          <Input
            className='fullContent'
            value={quantity}
            onChange={(e) => {
              if (
                Number(e.target.value) <=
                Number(orderDetailsItems?.Quantity ?? 0)
              )
                if (validationInputNumber(e.target.value)) {
                  setQuantity(Number(e.target.value));
                } else setQuantity(0);
              else setQuantity(Number(orderDetailsItems?.Quantity ?? 0));
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StockBreakQuantityModal;
